import React, { Component } from 'react';
import { number, bool, string, object, func, arrayOf, shape } from 'prop-types';

import CrowdSourcedMatchCard from './CrowdSourcedMatchCard';
import CompanySourcedMatchCard from '../../Jobs/JobCards/CompanySourcedMatchCard';
import SliderBar from '../../SliderBar/SliderBar';
import classnames from 'classnames';

export default class JobCurrentMatches extends Component {
  static propTypes = {
    editJobTitle: func,
    app: object,
    className: string,
    jobTitle: string,
    currency: string,
    orgJobId: number,
    jobSurveyList: object,
    updateMatchesAndPay: func,
    crowdSourceMatch: shape({
      matchId: number,
      payRange: arrayOf(number),
      payRangeScaleMin: number,
      payRangeScaleMax: number,
      jobTasks: arrayOf(string),
      loadingMatchDetails: bool,
      highVariance: bool,
      crowdSourceSurveyStatus: bool,
      updateMatch: func,
      weight: number,
      geo: number,
      adj: number
    }),
    companySourceMatch: shape({
      matchId: number,
      orgJobId: number,
      sourceMapId: number,
      payRange: arrayOf(number),
      payRangeScaleMin: number,
      payRangeScaleMax: number,
      jobDescription: string,
      loadingMatchDetails: bool,
      highVariance: bool,
      surveyStatus: bool,
      selectedDataCut: string,
      updateMatch: func,
      dataCuts: arrayOf(
        shape({
          job_scope: string
        })
      ),
      emptyDataCuts: arrayOf(
        shape({
          job_scope: string
        })
      ),
      cutId: number,
      title: string,
      weight: number,
      geo: number,
      adj: number
    }),
    onCutSelect: func,
    saveProfilesAnalyzed: func,
    jobSurveyActions: func,
    jobDetails: object,
    surveyDetails: object,
    loadDataCutsPanel: func,
    workLocationExact: string
  };

  constructor(props) {
    super(props);

    this.handleWeightChanged = this.handleWeightChanged.bind(this);
  }

  handleWeightChanged(newWeights) {
    // We get back a set of values, use these to determine the new weights.
    // Each value is between 0 and 1
    const crowdSourceValue = newWeights[0] / 100;
    const companySourceValue = newWeights[1] / 100;

    const proposedCrowdSourceMatch = {
      proposedAdj: this.props.crowdSourceMatch.adj,
      proposedGeo: this.props.crowdSourceMatch.geo,
      proposedWgt: crowdSourceValue,
      match_id: this.props.crowdSourceMatch.matchId
    };

    const proposedCompanySourceMatch = {
      proposedAdj: this.props.companySourceMatch.adj,
      proposedGeo: this.props.companySourceMatch.geo,
      proposedWgt: companySourceValue,
      match_id: this.props.companySourceMatch.matchId
    };

    const saveJobParams = {
      orgJobTitle: this.props.jobDetails.details.payscale_job_info.internalJobTitle,
      orgJobCode: this.props.jobDetails.details.org_job_code,
      workLocation: this.props.workLocationExact,
      orgJobId: this.props.orgJobId,
      jobDetails: this.props.jobDetails
    };

    const updatePayParams = {
      HighestDegreeEarned: this.props.jobDetails.details.HighestDegreeEarned
    };

    this.props.updateMatchesAndPay(
      [proposedCrowdSourceMatch, proposedCompanySourceMatch],
      this.props.orgJobId,
      saveJobParams,
      updatePayParams
    );
  }

  jobTaskString(jobTasks) {
    let tasks = '';
    if (jobTasks && jobTasks.length > 0) {
      tasks = jobTasks.reduce((tasksString, curTask) => {
        return tasksString + ', ' + curTask;
      });
    }
    return tasks;
  }

  render() {
    const {
      jobTitle,
      className,
      crowdSourceMatch,
      companySourceMatch,
      currency,
      app,
      editJobTitle,
      orgJobId,
      onCutSelect,
      jobDetails,
      surveyDetails,
      saveProfilesAnalyzed,
      jobSurveyList,
      jobSurveyActions,
      loadDataCutsPanel
    } = this.props;

    const matchClassName = classnames({
      'job-title-match': !companySourceMatch,
      'job-title-match--multi-match': companySourceMatch
    });

    const currentMatchesClassName = classnames({
      'job-current-matches': true,
      [`${className}`]: !!className
    });

    const crowdSourceTaskString = this.jobTaskString(crowdSourceMatch.jobTasks);

    let companySourceTaskString = '';
    if (companySourceMatch) {
      companySourceTaskString = companySourceMatch.jobDescription;
    }

    const payscaleSurveyRow = jobSurveyList.items.find(surveySingleRow => {
      const crowdSourcedSurveyCode = `PAY-${app.subsite.toUpperCase()}`;
      return surveySingleRow.survey_code.includes(crowdSourcedSurveyCode);
    });

    const competitiveSetItems =
      jobSurveyList && jobSurveyList.competitiveSetItems ? jobSurveyList.competitiveSetItems : [];

    const surveyDataLoading = jobSurveyList && jobSurveyList.loading ? jobSurveyList.loading : false;

    let hasCompanySourceMatch = false;
    if (companySourceMatch) hasCompanySourceMatch = true;

    let weightValue = 0;
    if (hasCompanySourceMatch) {
      // get total value between the two match weights
      const totalValue = companySourceMatch.weight + crowdSourceMatch.weight;
      // get the percentage ratio of the company match, anywhere between 0-100
      const companySourceMatchRatio = (companySourceMatch.weight / totalValue) * 100;
      // move the scale from 0-100 to 50 to -50 to match the slider
      weightValue = companySourceMatchRatio - 50;
    }

    return (
      <div className={currentMatchesClassName}>
        <div className={matchClassName}>
          <CrowdSourcedMatchCard
            payRange={crowdSourceMatch.payRange}
            payRangeScaleMax={crowdSourceMatch.payRangeScaleMax}
            payRangeScaleMin={crowdSourceMatch.payRangeScaleMin}
            jobTitle={companySourceMatch ? jobTitle : null}
            jobTasks={crowdSourceTaskString}
            loadingDetails={crowdSourceMatch.loadingMatchDetails}
            matchId={crowdSourceMatch.matchId}
            smallCard={false}
            onChangePayScaleMatchClick={editJobTitle}
            className="job-title-match__match-card"
            app={app}
            jobCurrency={currency}
            highVariance={crowdSourceMatch.highVariance}
            crowdSourceSurveyStatus={crowdSourceMatch.crowdSourceSurveyStatus}
            orgJobId={orgJobId}
            surveyRow={payscaleSurveyRow}
            jobDetails={jobDetails}
            saveProfilesAnalyzed={saveProfilesAnalyzed}
            competitiveSetItems={competitiveSetItems}
            jobSurveyActions={jobSurveyActions}
            surveyDataLoading={surveyDataLoading}
            hasCompanySourceMatch={hasCompanySourceMatch}
            showIncludeExclude={false}
            typeOfMatch="jobMatch"
          />
          {hasCompanySourceMatch && (
            <CompanySourcedMatchCard
              {...companySourceMatch}
              app={app}
              jobTasks={companySourceTaskString}
              jobTitle={companySourceMatch.title}
              jobCurrency={currency}
              onCutSelect={onCutSelect}
              surveyDetails={surveyDetails}
              loadDataCutsPanel={loadDataCutsPanel}
              showIncludeExclude={false}
              isPayscaleMatch={false}
              typeOfMatch="jobMatch"
              jobSurveyActions={jobSurveyActions}
            />
          )}
        </div>
        {hasCompanySourceMatch && (
          <div className="slider-bar-container">
            <p className="slider-bar-container__heading">Job Weight (%)</p>
            <SliderBar
              maxValue={50}
              minValue={-50}
              value={weightValue}
              stepValue={5}
              onValueChanged={this.handleWeightChanged}
            />
          </div>
        )}
      </div>
    );
  }
}
